export default "__VITE_ASSET__095c0f42__"